export default __webpack_public_path__ + "static/media/image-2.4d2ff0e9.gif";